exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pc .pc-saved .section {\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n\n.pc .pc-saved .section .section-header {\n  padding: 15px 16px;\n  border-bottom: 1px solid #999999;\n  margin: 0;\n}\n\n.pc .pc-saved .section .item-header {\n  border-bottom: 1px solid #999999;\n  font-family: \"JDSansPro-Medium\", \"Helvetica Neue\", \"Roboto\", helvetica, arial, sans-serif;\n  font-size: 16px;\n  font-weight: bold;\n  margin: 0;\n  padding: 15px 6px;\n}\n\n", ""]);

// exports
